@charset "UTF-8";
.reactions {
  cursor: pointer;
  margin-inline-end: 10px;
  position: relative;
  line-height: 1;
  top: 16px;
}

.hoverEmoji {
  font-size: 15px;
}

.emojiTrigger {
  position: relative;
  z-index: 1;
  cursor: pointer;
}
.emojiTrigger ~ .emojiTrigger {
  margin-inline-start: 2px;
}

.emoji {
  background-color: var(--messageIncomingBg);
  border-radius: 24px;
  border: solid 1px rgba(100, 100, 100, 0.3);
  font-size: 16px;
  padding: 2px 6px;
}
.emoji.isFromSelf {
  background-color: var(--messageOutgoingBg);
}
.emoji.showMore {
  color: var(--messageText);
}
.emoji.showMore::after {
  content: "⋯";
  display: inline-block;
  position: relative;
  top: 1px;
}

.emojiCount {
  bottom: 1px;
  color: var(--messageText);
  font-size: 12px;
  margin-inline-start: 3px;
  margin-inline-end: 1px;
  position: relative;
}

.openReactionsListDialogButton {
  position: absolute;
  inset: 0;
  border: none;
  background: transparent;
}